import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar/Navbar';
import { useState } from 'react';
import Menu from './components/Menu/Menu';
import Home from './components/Pages/Home';
import Footer from './components/Footer/Footer';
import ContactPage from './components/Pages/ContactPage';
import TermsCondition from './components/Pages/TermsCondition';
import AboutUsPage from './components/Pages/AboutUsPage';
import ApiPage from './components/Pages/ApiPage';



function App() {

  const [clicked, setClicked] = useState(false);



  return (
    <div className="App">
      <Router>
        <Navbar clicked={clicked} setClicked={setClicked} />
        {clicked ? <Menu clicked={clicked} setClicked={setClicked} /> : null}
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/privacy-policy' element={<TermsCondition />} />
          <Route path='/about-us' element={<AboutUsPage />} />
          <Route path='/apis' element={<ApiPage />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
